<template>
  <div class="w-full">
    <templates-picker
      v-if="!selectedWaTemplate"
      :inbox-id="inboxId"
      :template-filter="templateFilter"
      :empty-state="emptyState"
      :selected-template="highlightedTemplate"
      @onSelect="onSelectTemplate"
      @create-template="$emit('create-template')"
    />
    <template-parser
      v-else
      ref="parser"
      :template="selectedWaTemplate"
      :show-actions="showActions"
      @resetTemplate="onResetTemplate"
      @validChange="$emit('templateValid', $event)"
      @sendMessage="onSendMessage"
    />
  </div>
</template>

<script>
import TemplatesPicker from './OnlineWaTemplatesPicker.vue';
import TemplateParser from './OnlineWaTemplateParser.vue';
export default {
  components: {
    TemplatesPicker,
    TemplateParser,
  },
  props: {
    inboxId: {
      type: Number,
      default: undefined,
    },
    show: {
      type: Boolean,
      default: true,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    templateFilter: {
      type: Function,
      default: null,
    },
    emptyState: {
      type: Object,
      default: null,
    },
    confirmSelection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedWaTemplate: null,
      highlightedTemplate: null,
    };
  },
  watch: {
    inboxId() {
      this.selectedWaTemplate = null;
      this.highlightTemplate(null);
    },
    templateFilter() {
      this.highlightTemplate(null);
    },
  },
  methods: {
    onSelectTemplate(template) {
      if (this.confirmSelection) {
        this.highlightTemplate(template);
      } else {
        this.pickTemplate(template);
      }
    },
    highlightTemplate(template) {
      this.highlightedTemplate = template;
      this.$emit('highlightTemplate', !!template);
    },
    next() {
      if (this.highlightedTemplate) this.pickTemplate(this.highlightedTemplate);
    },
    pickTemplate(template) {
      this.$emit('pickTemplate', true);
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.$emit('pickTemplate', false);
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('on-send', message);
    },
    send() {
      this.$refs.parser?.sendMessage();
    },
    validate() {
      this.$refs.parser?.$v.$touch();
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<style></style>
